import {
  InfoOutlined,
  CheckCircleOutlined,
  CancelOutlined,
  ErrorOutline,
} from '@mui/icons-material';
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import {
  ContainerDialog,
  ContainerIcon,
  DialogTitle,
  DialogContent,
  DialogSubtitle,
  DialogFooter,
} from './styles';

interface ModalPasswordFileProps {
  open: boolean;
  onConfirm: (password: string) => void;
  title: string;
  btnTextConfirm: string;
  isWrongPassword: boolean;
  onCancel: () => void;
}

export const ModalPasswordFile = ({
  open,
  onConfirm,
  title,
  btnTextConfirm,
  isWrongPassword,
  onCancel,
}: ModalPasswordFileProps) => {
  const [password, setPassword] = useState('');

  return (
    <ContainerDialog
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '33.75rem',
            display: 'flex',
            padding: '20px ',
          },
        },
      }}
      open={open}
      keepMounted
      onClose={() => undefined}
      aria-describedby="alert-dialog-slide-description"
      className="modal"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogSubtitle className="alert-subtitle">
          <Box>
            <TextField
              fullWidth
              error={isWrongPassword}
              type="password"
              onChange={event => setPassword(event.target.value)}
            />
          </Box>
        </DialogSubtitle>
      </DialogContent>

      <DialogFooter>
        <Button
          color="inherit"
          variant="outlined"
          onClick={onCancel}
          sx={{
            marginLeft: '20px',
            color: '#00000',
            padding: '16px 22px',
          }}
        >
          Fechar
        </Button>
        <Button
          color="primary"
          variant="contained"
          onClick={() => onConfirm(password)}
          sx={{
            marginLeft: '20px',
            color: '#ffffff',
            padding: '16px 22px',
          }}
        >
          {btnTextConfirm}
        </Button>
      </DialogFooter>
    </ContainerDialog>
  );
};
